import _extends from "@babel/runtime-corejs3/helpers/extends";
import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { InputField, Button, SelectField } from '@unite-us/ui';
import { get, includes } from 'lodash';
import { Field, Form } from 'react-final-form';
import { callbacks, getAdapter, trackEvent } from '../../../config/api';
import { FACESHEET } from '../../../constants/eventConstants';
import Spinner from '../../common/spinners/Spinner';
import callOrLog from '../../../constants/callOrLog';
function SexualOrientationForm(props) {
  var contact = props.contact,
    sexualOrientationsEnums = props.sexualOrientationsEnums;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSubmitting = _useState2[0],
    setIsSubmitting = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isSexualOrientationOtherSelected = _useState4[0],
    setIsSexualOrientationOtherSelected = _useState4[1];
  var onCancel = function onCancel() {
    props.closeModal();
  };
  var onSubmit = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(values) {
      var _values$sexuality, _values$sexuality_oth;
      var contact, contactId, newContact;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setIsSubmitting(true);
            contact = props.contact;
            contactId = get(contact, 'id');
            newContact = {
              sexuality: (_values$sexuality = values.sexuality) !== null && _values$sexuality !== void 0 ? _values$sexuality : null,
              sexuality_other: isSexualOrientationOtherSelected ? (_values$sexuality_oth = values.sexuality_other) !== null && _values$sexuality_oth !== void 0 ? _values$sexuality_oth : null : null
            };
            _context.next = 6;
            return getAdapter('coreApi').updateRecord("person", contactId, newContact);
          case 6:
            setIsSubmitting(false);
            callOrLog(function () {
              return trackEvent(FACESHEET.sexualityUpdated);
            });
            props.closeModal();
            callbacks.onClientSaved();
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function onSubmit(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  return isSubmitting ? /*#__PURE__*/React.createElement(Spinner, null) : /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit,
    validate: function validate(values) {
      setIsSexualOrientationOtherSelected(includes(values === null || values === void 0 ? void 0 : values.sexuality, 'other'));
    },
    initialValues: contact,
    render: function render(_ref2) {
      var handleSubmit = _ref2.handleSubmit,
        submitting = _ref2.submitting;
      return /*#__PURE__*/React.createElement("form", {
        className: "content-with-actions",
        onSubmit: handleSubmit
      }, /*#__PURE__*/React.createElement("div", {
        className: "content-container",
        style: {
          height: '350px'
        }
      }, /*#__PURE__*/React.createElement(Field, {
        name: "sexuality"
      }, function (params) {
        return /*#__PURE__*/React.createElement(SelectField, _extends({
          id: "sexuality",
          label: "Sexual Orientation",
          multiple: true,
          options: sexualOrientationsEnums,
          shouldSort: false,
          labelKey: "display_name",
          valueKey: "value",
          clearable: true
        }, params));
      }), isSexualOrientationOtherSelected && /*#__PURE__*/React.createElement(Field, {
        name: "sexuality_other"
      }, function (params) {
        return /*#__PURE__*/React.createElement(InputField, _extends({
          id: "sexuality-other",
          inline: false,
          label: "Other (Please Specify)",
          type: "text"
        }, params));
      })), /*#__PURE__*/React.createElement("div", {
        className: "actions"
      }, /*#__PURE__*/React.createElement("span", {
        className: "action-item"
      }, /*#__PURE__*/React.createElement(Button, {
        id: "edit-sexuality-cancel-btn",
        disabled: submitting,
        label: "Cancel",
        onClick: onCancel
      })), /*#__PURE__*/React.createElement("span", {
        className: "action-item"
      }, /*#__PURE__*/React.createElement(Button, {
        id: "edit-sexuality-save-btn",
        disabled: submitting,
        label: "Save",
        primary: true,
        onClick: function onClick() {
          handleSubmit();
        }
      }))));
    }
  });
}
SexualOrientationForm.propTypes = {
  closeModal: PropTypes.func,
  contact: PropTypes.shape({
    id: PropTypes.string,
    sexuality: PropTypes.array,
    sexuality_other: PropTypes.string
  }),
  sexualOrientationsEnums: PropTypes.array.isRequired
};
export default SexualOrientationForm;
//# sourceMappingURL=SexualOrientationForm.js.map